import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { DatePipe } from '@angular/common';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../../../core/reducers';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/core/auth/_services';
import { StringUtilsService } from '../../../../core/services/string-utils.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  CategoryService,
  ContactRelationshipsService,
  ContactsService,
  NoteMode,
  NoteService,
  PatientsService,
} from '../../../../core/lists';
import { GeneralAutocompleteComponent } from '../../../partials/layout/general-autocomplete/general-autocomplete.component';
import { retry, take, tap } from 'rxjs/operators';
import { NewAttemptDialogComponent } from '../new-attempt-dialog/new-attempt-dialog.component';
import { FollowUpService } from '../../../../core/services/follow-up.service';
import { Subscription } from 'rxjs';
import { currentUser } from 'src/app/core/auth';
import { CommentsService } from '../../../../core/services/comments.service';
import { CommunicationsService, TaskService } from '../../../../core/timeline/_services';
import { AddNoteDialogComponent } from '../../apps/lists/notes/add-note-dialog/add-note-dialog.component';
import { MeetingViewDialogComponent } from '../../apps/timeline/meetings/meeting-view/meeting-view-dialog.component';
import { ViewCommunicationComponent } from '../../apps/timeline/view-communication/view-communication.component';
import { FilteredViewService } from '../../../../core/services/filtered-view.service';
import { CreateWorkflowDialogComponent } from '../../workflow/create-workflow-dialog/create-workflow-dialog.component';
import { WorkflowService } from '../../workflow/_services/workflow.service';
import { MedReviewService } from '../../med-review/services/med-review.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AttemptListComponent } from '../attempt-list/attempt-list.component';
import { LayoutUtilsService, MessageType } from '../../../../core/_base/crud';
import { TaskMode } from '../../calendar/enums';
import { Task } from '../../calendar/models';
import { ConfirmActionDialogComponent } from '../../../partials/content/crud';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'kt-follow-up-dialog',
  templateUrl: './follow-up-dialog.component.html',
  styleUrls: ['./follow-up-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FollowUpDialogComponent implements OnInit, OnDestroy {
  private workflow: any;
  private statusesList: any[] = [];
  private relatedIds: any[] = [];
  private attemptComment = '';
  private isClicked = true;
  contactId = null;
  patients: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<FollowUpDialogComponent>,
    private userService: UserService,
    private store: Store<AppState>,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef,
    public dialog: MatDialog,
    public datePipe: DatePipe,
    private fb: FormBuilder,
    private followUpService: FollowUpService,
    private commentsService: CommentsService,
    private contactsService: ContactsService,
    private workflowService: WorkflowService,
    private taskService: TaskService,
    private communicationsService: CommunicationsService,
    public stringUtils: StringUtilsService,
    private layoutUtilsService: LayoutUtilsService,
    private noteService: NoteService,
    private categoryService: CategoryService,
    private filterViewService: FilteredViewService,
    private medReviewService: MedReviewService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private contactRelationshipsService: ContactRelationshipsService,
    private patientsService: PatientsService,
  ) {}

  userAutocompleteCall = this.userService.searchUsers.bind(this.userService);
  @ViewChild('createdByAutocomplete') createdByAutocomplete: GeneralAutocompleteComponent;
  followUpForm: FormGroup;
  hasFormErrors: boolean;
  followUp;
  attempt;
  attempts_count = 0;
  attempt_reason;
  mode = 'CREATE';
  comments = [];
  showComments = true;
  follow_up_responsibles = [];
  contactAutocompleteCall = this.contactsService.searchContactsFollowups.bind(
    this.contactsService,
    this.data.relatedIds,
  );
  relatedPatientsAutocompleteCall =
    this.contactRelationshipsService.findContactRelationshipsImplicit.bind(
      this.contactRelationshipsService,
      null,
      'PATIENT',
    );
  @ViewChild('followupContactAutocomplete')
  followupContactAutocomplete: GeneralAutocompleteComponent;
  session;
  assigneeAutocompleteCall = this.userService.searchUser.bind(this.userService);
  @ViewChild('assigneeAutocomplete') assigneeAutocomplete: GeneralAutocompleteComponent;
  @ViewChild('relatedPatientsAutocomplete')
  relatedPatientsAutocomplete: GeneralAutocompleteComponent;
  subscriptions: Subscription[] = [];
  currentUser;
  task: any;
  meeting: any;
  viewMode = this.data.viewMode;
  disableSaveButton = this.data.viewMode;
  loadAssign = (a) => {
    return this.userService.searchUser(null, a).pipe(
      tap(
        (data) =>
          (data.data = data.data.map((val: any) => {
            return {
              responsible_id: val.id,
              responsible_type: 'USER',
              fullName: val.fullName,
              name: val.userName,
            };
          })),
      ),
    );
  };

  ngOnInit() {
    if (
      this.data &&
      !this.data.followup &&
      this.data.body &&
      this.data.type !== 'FILTERED_SESSION'
    ) {
      this.followUpService
        .getFollowUpById(this.data.type, this.data.body.id)
        .subscribe((followup) => {
          this.followUp = followup;
          if (this.followUp && this.followUp.id) {
            this.mode = 'UPDATE';
            this.attempts_count = this.followUp.attempts_count;
            this.getComments(this.followUp.id);
          }
          this.createForm();
          this.fillCreatedByAndAssignTo();
          return;
        });
    }
    if (this.data && this.data.followup) {
      this.followUp = this.data.followup;
      this.mode = 'UPDATE';
      this.attempts_count = this.followUp.attempts_count;
      this.getComments(this.followUp.id);
    }

    this.createForm();
    setTimeout(() => {
      this.fillCreatedByAndAssignTo();
    });
    if (this.data.body_id && this.data.calendar) {
      this.getBody(this.data.type, this.data.body_id);
    }
  }

  getBody(type, id) {
    switch (type) {
      case 'TASK': {
        this.taskService
          .getTaskV3(id, true)
          .pipe(take(1))
          .subscribe((res) => {
            if (res?.data) {
              this.data.title = '';
              this.task = res.data;
              this.relatedIds = [];

              if (this.task.task_entities?.length)
                this.task.task_entities.forEach((e) => this.relatedIds.push(e.entity_id));

              this.contactAutocompleteCall = this.contactsService.searchContactsFollowups.bind(
                this.contactsService,
                this.relatedIds,
              );
            }
          });

        break;
      }
      case 'WORKFLOW': {
        this.followUpService.getWorkflowQueueById(id).subscribe((result) => {
          if (result.data && result.data.workflow_queue && result.data.workflow_queue.workflow) {
            this.data.title = result.data.workflow_queue.workflow.name;
            this.workflow = result.data;
            const current = this.workflow.workflow_queue.workflow_queue_entities;
            current.forEach((element) => {
              this.relatedIds = this.relatedIds.concat(element.ids);
              this.relatedIds = this.arrayUnique(this.relatedIds);
            });
            this.contactAutocompleteCall = this.contactsService.searchContactsFollowups.bind(
              this.contactsService,
              this.relatedIds,
            );
          }
        });
        break;
      }
      case 'NOTE': {
        this.noteService
          .getNoteById(id)
          .pipe(take(1))
          .subscribe((res) => {
            if (!res?.data) return;

            this.data.title = res.data.subject;
            this.relatedIds = [];

            if (res.data.entities?.length) {
              res.data.entities.forEach((e) => this.relatedIds.push(e.id));
              this.contactAutocompleteCall = this.contactsService.searchContactsFollowups.bind(
                this.contactsService,
                this.relatedIds,
              );
            }
          });

        break;
      }
      case 'MEETING': {
        this.communicationsService.getCommunicationById(id).subscribe((res) => {
          if (res.data && res.data.id) {
            this.data.title = res.data.subject;
            this.meeting = res.data;
            this.relatedIds = [];
            this.meeting.related_to_list.forEach((rela) => {
              this.relatedIds.push(rela.id);
            });
            this.contactAutocompleteCall = this.contactsService.searchContactsFollowups.bind(
              this.contactsService,
              this.relatedIds,
            );
          }
        });
        break;
      }
      case 'MEDREVIEW': {
        this.medReviewService.getPatientMedReview(id).subscribe((res: any) => {
          this.data.title = res.patient_name;
          this.relatedIds.push(res.patient_id);
          this.contactAutocompleteCall = this.contactsService.searchContactsFollowups.bind(
            this.contactsService,
            this.relatedIds,
          );
        });
        break;
      }
    }
  }

  arrayUnique(array) {
    const a = array.concat();
    for (let i = 0; i < a.length; ++i) {
      for (let j = i + 1; j < a.length; ++j) {
        if (a[i] === a[j]) a.splice(j--, 1);
      }
    }
    return a;
  }

  getPatient(value) {
    if (value && value.id && this.patients) {
      this.patients.filter((item) => {
        item.id === value.id;
      });
    }
  }

  fillCreatedByAndAssignTo() {
    this.store.pipe(select(currentUser)).subscribe((res) => {
      if (res) {
        this.currentUser = res;
        if (this.mode === 'CREATE') {
          this.followUpForm.controls.createdBy.setValue(res);
          this.createdByAutocomplete.setValue(res);
        }
        const assign = {
          responsible_id: res.id,
          responsible_type: 'USER',
          fullName: res.fullName,
          name: res.userName,
        };
        if (!this.follow_up_responsibles) {
          this.follow_up_responsibles = [assign];
        } else {
          const ff = this.follow_up_responsibles.find((f) => {
            return f.responsible_id === res.id;
          });
          if (!ff) {
            this.follow_up_responsibles.push(assign);
          }
        }
        this.cdr.detectChanges();
      }
    });
    if (this.mode === 'UPDATE')
      this.taskService.getUsersbyId([this.followUp.created_by]).subscribe((res) => {
        if (res.pageOfItems) {
          this.followUpForm.controls.createdBy.setValue(res.pageOfItems[0]);
          this.createdByAutocomplete.setValue(res.pageOfItems[0]);
          this.cdr.detectChanges();
        }
      });
  }

  getComments(followup_id) {
    let users = [];
    let resultOfCOmment = [];

    this.followUpService.getFollowupComments(followup_id).subscribe((res) => {
      if (res && res.data) {
        resultOfCOmment = res.data;
        for (const c of resultOfCOmment) {
          c.editMode = false;
          users.push(c.last_modified_user);
        }
      }
      if (users.length > 0)
        this.userService.getUserByUserName(users).subscribe((result) => {
          if (result.code === 200) {
            users = result.pageOfItems;
            for (const c of resultOfCOmment) {
              c.userName = c.last_modified_user;
              for (const x of users) {
                if (x.userName === c.last_modified_user) {
                  c.profileUrl = x.profileUrl;
                }
              }
            }
            this.comments = resultOfCOmment;
            this.cdr.detectChanges();
          }
        });
    });
  }

  createForm() {
    if (this.followUp && this.followUp.related_patients) {
      this.patientsService
        .getPatientByIds(
          this.followUp.related_patients.map(function (obj) {
            return obj.id;
          }),
        )
        .subscribe((resPatients) => {
          const relatedPatient = this.followUp.related_patients.map(function (obj) {
            return resPatients.data.filter((item) => {
              if (item.id === obj.id) {
                return (item.entity_id = item.id);
              }
            })[0];
          });
          this.followUpForm.get('relatedPatients').setValue(relatedPatient);
        });
    }
    this.followUpForm = this.fb.group({
      followupNote: [this.followUp ? this.followUp.note : ''],
      followupContact: [],
      createdBy: [],
      assignedTo: [this.follow_up_responsibles],
      relatedPatients: [],
      status: [this.followUp ? this.followUp.status : 'ACTIVE', Validators.required],
      followupDate: [
        new Date(
          this.followUp && this.followUp.follow_up_date
            ? new Date(this.followUp.follow_up_date + ' UTC')
            : new Date(),
        ),
        Validators.required,
      ],
    });
    if (this.mode === 'UPDATE' && this.followUp.contact_id) {
      this.contactsService.getContactsByIds([this.followUp.contact_id]).subscribe((res) => {
        this.followUpForm.controls.followupContact.setValue(res.data[0]);
        this.followUpForm.controls.followupContact.updateValueAndValidity();
        this.followupContactAutocomplete.setValue(res.data[0]);
        this.cdr.detectChanges();
      });
    }
    if (this.data.type === 'FILTERED_SESSION' && this.data.body && this.data.body.id) {
      this.contactsService.getContactsByIds([this.data.body.id]).subscribe((res) => {
        this.followUpForm.controls.followupContact.setValue(res.data[0]);
        this.followUpForm.controls.followupContact.updateValueAndValidity();
        this.followupContactAutocomplete.setValue(res.data[0]);
        this.cdr.detectChanges();
      });
    }
    if (this.mode === 'UPDATE' && this.followUp.follow_up_responsibles.length > 0) {
      this.taskService
        .getUsersbyId(this.followUp.follow_up_responsibles.map((user) => user.responsible_id))
        .subscribe((res) => {
          if (res.pageOfItems) {
            this.followUpForm.get('assignedTo').setValue(
              res.pageOfItems.map((user) => {
                return {
                  responsible_id: user.id,
                  responsible_type: 'USER',
                  fullName: user.fullName,
                  name: user.userName,
                };
              }),
            );
            this.cdr.detectChanges();
          }
        });
    }
    if (this.data.type === 'FILTERED_SESSION') {
      this.followUpForm.controls.followupNote.setValue(
        this.data.note ? this.data.note : this.followUp ? this.followUp.note : '',
      );
      this.followUpForm.controls.followupContact.setValue(this.data.body);
      if (this.followupContactAutocomplete)
        this.followupContactAutocomplete.setValue(this.data.body);
    }
  }

  getTitle() {
    if (this.followUp && this.followUp.id > 0) {
      return 'Update Follow-up';
    }
    return 'Create Follow-up';
  }

  ngOnDestroy() {
    this.cdr.detach();
  }

  close() {
    this.dialogRef.close();
  }

  onContactChange(val) {
    if (val) {
      this.relatedPatientsAutocompleteCall =
        this.contactRelationshipsService.findContactRelationshipsImplicit.bind(
          this.contactRelationshipsService,
          val.id,
        );
      this.contactId = val.id;
    }
    this.followUpForm.controls.followupContact.setValue(val);
    this.followUpForm.controls.followupContact.updateValueAndValidity();
  }

  onCreatedByChange(val) {
    this.followUpForm.controls.createdBy.setValue(val);
    this.followUpForm.controls.createdBy.updateValueAndValidity();
  }

  displayUsers(user) {
    let res = '';
    if (user) {
      res += user.fullName;
    }
    if (user && user.name) {
      res += '  ' + `<small class="text-muted">` + user.name + `</small>`;
    }
    return res;
  }

  displayUsersSelected(user) {
    let res = '';
    if (user) {
      res += user.fullName;
    }
    return res;
  }

  filterAssigneeFn(assignee: any): string {
    let res = '';
    if (assignee) {
      res += assignee.fullName;
    }
    if (assignee && assignee.name) {
      res += '  ' + `<small class="text-muted">` + assignee.name + `</small>`;
    }
    return res;
  }

  onAssigneeChange(val) {
    const users = val.map((item) => {
      if (item && !item.responsible_id) {
        const user = {
          responsible_id: item.id,
          responsible_type: 'USER',
          fullName: item.fullName,
          name: item.name,
        };
        return user;
      }
      return item;
    });
    this.followUpForm.controls.assignedTo.setValue(users);
    this.followUpForm.controls.assignedTo.updateValueAndValidity();
  }

  onRelatedPatientsChange(val) {
    this.followUpForm.controls.relatedPatients.setValue(val);
    this.followUpForm.controls.relatedPatients.updateValueAndValidity();
  }

  formatNewAssigneeFn(assignee: any) {
    return assignee;
  }

  openNewAttemptDialog() {
    if (this.viewMode) {
      const cofirmActionDialogRef = this.dialog.open(ConfirmActionDialogComponent, {
        data: {
          title: 'New Attempt Confirmation',
          description:
            'If you add a new attempt, the follow up status will change to active. \n Do you still want to proceed?',
          waitDesciption: 'Loading...',
        },
        width: '440px',
      });
      cofirmActionDialogRef.afterClosed().subscribe((res) => {
        if (!res) {
          this.dialogRef.close();
        }
        this.disableSaveButton = false;
        this.displayAttemptDialog();
      });
    } else {
      this.displayAttemptDialog();
    }
  }

  displayAttemptDialog() {
    const dialogRef = this.dialog.open(NewAttemptDialogComponent, {
      data: {
        body: this.followUp,
        followupContact: this.followUpForm.get('followupContact').value,
        followupDate: this.followUpForm.get('followupDate').value,
        attempt_count: this.attempts_count,
        // comments: this.comments,
        transaction: this.data.body ? this.data.body : null,
        type: this.data.type,
        transaction_id: this.data.body_id,
        relatedIds: this.data.calendar ? this.relatedIds : this.data.relatedIds,
      },
      width: '500px',
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.attempts_count = result.attempts_count;
        this.attempt_reason = result.reason;
        this.followUpForm.get('followupDate').setValue(result.attempt.followupDate);
        this.followUpForm.controls.followupContact.setValue(result.attempt.followupContact);
        this.followUpForm.get('status').setValue('ACTIVE');
        this.followupContactAutocomplete.setValue(result.attempt.followupContact);
        this.attemptComment = result.attempt.attempt_comment;
        this.doFollowUp(result.fromAttempt);

        this.cdr.detectChanges();
      }
    });
  }
  onSubmit() {
    this.hasFormErrors = false;
    const controls = this.followUpForm.controls;
    this.createdByAutocomplete.updateValueAndValidity();
    this.followupContactAutocomplete.updateValueAndValidity();

    /** check form */
    if (this.followUpForm.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      this.hasFormErrors = true;
      return;
    }
    this.doFollowUp(null);
  }

  doFollowUp(attempt) {
    const body = {
      transformation_id: undefined,
      transaction_type: undefined,
      follow_up_date: undefined,
      status: undefined,
      related_patients: undefined,
      follow_up_responsibles: undefined,
      note: undefined,
      contact_id: undefined,
      id: undefined,
      attempts_count: 0,
      reason_id: undefined,
      created_by: undefined,
      attempt_comment: '',
      name: null,
    };
    body.transformation_id = this.data.body ? this.data.body.id : this.data.body_id;
    body.transaction_type = this.data.type;
    body.follow_up_date = this.datePipe.transform(
      this.followUpForm.get('followupDate').value,
      'yyyy-MM-dd HH:mm:ss',
      'utc',
    );
    body.status = this.followUpForm.get('status').value;
    body.follow_up_responsibles = this.followUpForm.get('assignedTo').value;
    body.related_patients = this.followUpForm.get('relatedPatients').value;
    body.note = this.followUpForm.get('followupNote').value;
    body.contact_id = this.followUpForm.get('followupContact').value
      ? this.followUpForm.get('followupContact').value.id
      : undefined;
    body.created_by = this.followUpForm.get('createdBy').value
      ? this.followUpForm.get('createdBy').value.id
      : undefined;
    if (this.data.type === 'TASK' || this.data.type === 'WORKFLOW') {
      body.name = this.data.title;
    }
    if (this.data.session) {
      body.transformation_id = this.data.session;
    }
    if (this.followUp && this.followUp.id) {
      body.id = this.followUp.id;
      body.attempts_count = this.attempts_count;
      body.reason_id = this.attempt_reason && this.attempt_reason.id ? this.attempt_reason.id : 0;
      body.attempt_comment = this.attemptComment;

      this.updateFollowUp(body, attempt);
      return;
    }
    this.createFollowUp(body, attempt);
  }

  createFollowUp(followUp, attempt) {
    this.followUpService.createFollowUp(followUp).subscribe((res) => {
      if (attempt) {
        return;
      }

      this.dialogRef.close({ followup: res });
    });
  }

  updateFollowUp(followUp, attempt) {
    this.followUpService.updateFollowUp(followUp).subscribe((res) => {
      if (res) {
        if (attempt) {
          if (this.attemptComment !== '') {
            const body = {
              comment: this.attemptComment,
              transaction_id: this.data.body ? this.data.body.id : this.data.body_id,
            };
            this.followUpService
              .postFollowUpComment(this.data.type, this.followUp.id, body)
              .subscribe((result) => {
                if (result) {
                  setTimeout(() => {
                    const newComment = result;
                    newComment.profileUrl = this.currentUser.profileUrl;
                    newComment.editMode = false;
                    newComment.userName = newComment.last_modified_user;
                    this.comments.unshift(newComment);
                    this.cdr.detectChanges();
                  }, 2000);
                }
              });
          }
          return;
        }

        this.dialogRef.close({ followup: res });
      }
    });
  }

  seeAllComments(val) {
    this.comments = [];
    if (val) {
      let type = '';
      if (this.data.type === 'TASK') {
        type = 'TASK';
      }
      if (this.data.type === 'WORKFLOW') {
        type = 'workflow_queues';
      }
      this.getAllComments(type, this.data.body ? this.data.body.id : this.data.body_id);
      return;
    }
    this.getComments(this.followUp.id);
  }

  getAllComments(type, id) {
    let users = [];
    let resultOfCOmment = [];

    this.commentsService.getComments(type, id).subscribe((res) => {
      if (res && res.data) {
        resultOfCOmment = res.data;
        for (const c of resultOfCOmment) {
          c.editMode = false;
          users.push(c.last_modified_user);
        }
      }
      if (users.length > 0)
        this.userService.getUserByUserName(users).subscribe((result) => {
          if (result.code === 200) {
            users = result.pageOfItems;
            for (const c of resultOfCOmment) {
              c.userName = c.last_modified_user;
              for (const x of users) {
                if (x.userName === c.last_modified_user) {
                  c.profileUrl = x.profileUrl;
                }
              }
            }
            this.comments = resultOfCOmment;
            this.cdr.detectChanges();
          }
        });
    });
  }

  getName() {
    if (this.data.type !== 'FILTERED_SESSION') return this.data.type;
    return 'Filtered Session';
  }

  getTitleOfType() {
    if (this.data.type !== 'FILTERED_SESSION') return this.data.title;
    return;
  }

  openNoteDialog(noteId: number): void {
    if (!noteId) return;

    this.noteService
      .getNoteById(noteId)
      .pipe(take(1))
      .subscribe((res) => {
        if (!res?.data) return;

        const dialogConfig = new MatDialogConfig();

        dialogConfig.disableClose = true;
        dialogConfig.closeOnNavigation = true;
        dialogConfig.width = '95vw';
        dialogConfig.maxWidth = '95vw';
        dialogConfig.data = { mode: NoteMode.UPDATE, fromContact: false, note: res.data };

        this.dialog.open(AddNoteDialogComponent, dialogConfig);
      });
  }

  updateTask(task: Task, stepId: number): void {
    if (!task?.id) return;

    if (task.lock) {
      const message = 'This task is locked by ' + task.locked_by;

      this.layoutUtilsService.showActionNotification(
        message,
        MessageType.Update,
        3000,
        false,
        false,
      );
      return;
    }

    this.taskService
      .updateTaskLock(task.id, { lock: true })
      .pipe(take(1))
      .subscribe((res) => {
        if (!res?.ok) return;

        const dialogConfig = new MatDialogConfig();

        dialogConfig.disableClose = true;
        dialogConfig.closeOnNavigation = true;
        dialogConfig.width = '95vw';
        dialogConfig.maxWidth = '95vw';
        dialogConfig.data = {
          mode: TaskMode.UPDATE,
          fromCalendar: this.data.calendar,
          task,
          stepId,
        };

        // Loaded lazily: CreateTaskComponent opens this dialog, so a static import would be circular.
        import('../../calendar/create-task/create-task.component').then(
          ({ CreateTaskComponent }) => {
            const dialogRef = this.dialog.open(CreateTaskComponent, dialogConfig);

            dialogRef
              .afterClosed()
              .pipe(take(1))
              .subscribe(() => {
                this.taskService
                  .updateTaskLock(task.id, { lock: false })
                  .pipe(take(1), retry(3))
                  .subscribe();
              });
          },
        );
      });
  }

  viewMeeting(meeting) {
    const dialogRef = this.dialog.open(MeetingViewDialogComponent, {
      data: { meeting, fromCalendar: this.data.calendar },
      width: '500px',
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (!res) {
        return;
      }
    });
  }

  openCard(workflow) {
    this.workflowService
      .getWorkflowStatusesList(workflow.workflow_queue.workflow.workflow_group_id)
      .subscribe((response) => {
        response.data.map((status) => {
          this.statusesList.push(status);
        });
        this.dialog.open(CreateWorkflowDialogComponent, {
          data: {
            workflow,
            isNew: false,
            header: undefined,
            statuses: this.statusesList,
            fromCalendar: this.data.calendar,
          },
          width: '90vw',
          maxWidth: 'unset !important',
          disableClose: true,
          hasBackdrop: true,
          closeOnNavigation: true,
          autoFocus: true,
        });
      });
  }

  viewSession(item) {
    let duration: number | null = null;
    if (item.created && item.ended) {
      const from = new Date(item.created);
      const to = new Date(item.ended);
      const timeDiff = to.getTime() - from.getTime(); // Explicitly get milliseconds
      duration = Math.round(((timeDiff % 86400000) % 3600000) / 60000);
    }
    const notDialogRef = this.dialog.open(ViewCommunicationComponent, {
      data: {
        session: item,
        type: 'session',
        duration,
        fromDate: item.created,
        toDate: item.ended,
        userName: item.username,
      },
      width: '900px',
    });
    notDialogRef.afterClosed().subscribe((res) => {
      if (!res) {
        return;
      }
    });
  }

  openTransaction() {
    if (!this.data.calendar) {
      this.dialogRef.close();
      return;
    }
    if (this.data.type) {
      switch (this.data.type) {
        case 'NOTE': {
          this.openNoteDialog(this.data.body_id);
          break;
        }
        case 'WORKFLOW': {
          this.openCard(this.workflow);
          break;
        }
        case 'TASK': {
          this.updateTask(this.task, this.data.body_id);
          break;
        }
        case 'FILTERED_SESSION': {
          if (this.data.body_id)
            this.filterViewService.getSessionById(this.data.body_id).subscribe((res) => {
              if (res) this.viewSession(res);
            });
          break;
        }
        case 'MEETING': {
          this.viewMeeting(this.meeting);
          break;
        }
        case 'MEDREVIEW': {
          this.router.navigate(['med-review/board', this.followUp.transformation_id], {
            relativeTo: this.activatedRoute,
          });
          this.dialog.closeAll();
          break;
        }
      }
    }
  }

  openHistory() {
    if (this.isClicked)
      this.followUpService.getHistory(this.followUp.id).subscribe((result) => {
        this.isClicked = false;
        if (result) {
          const contacts = [];
          result.forEach((element) => {
            if (element.contact_id) contacts.push(element.contact_id);
          });
          this.contactsService.getContactsByIds(contacts).subscribe((res) => {
            const dialogRef = this.dialog.open(AttemptListComponent, {
              data: {
                attempts: result,
                contacts: res ? res.data : [],
              },
              width: '1200px',
            });
            dialogRef.afterClosed().subscribe(() => {
              this.isClicked = true;
            });
          });
        }
      });
  }
}
